var _defs, _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAccounting01({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 18 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M9.16,12.82a4.39,4.39,0,0,0,1,2.76l-1.88,1L8,16.69v-.26Q8,12.61,8,8.8a.34.34,0,0,1,.22-.35l6.32-3.19.25-.12V8.56a4.37,4.37,0,0,0-1.21-.17A4.43,4.43,0,0,0,9.16,12.82Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M.71,5.14l1,.5c.35.17.69.36,1.05.52a.28.28,0,0,1,.18.31V9.59c0,.37.13.49.48.39a.58.58,0,0,1,.71.22c.1.13.23.24.34.36s.24.21.38.11A.49.49,0,0,0,5,10.33C5,9.41,5,8.5,5,7.58V7.33l.19.09c.72.36,1.43.71,2.14,1.08a.26.26,0,0,1,.13.19v7.89a.81.81,0,0,1,0,.09l-.21-.1L1.09,13.33a.67.67,0,0,1-.4-.63q0-3.7,0-7.41A1.06,1.06,0,0,1,.71,5.14Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M14.5,4.69l-1.9,1L8.1,7.93a.68.68,0,0,1-.7,0C6.72,7.57,6,7.23,5.32,6.87l.53-.27,6.08-3.08a.37.37,0,0,1,.38,0l2,1.06Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M10.06,2.35,7.44,3.67l-4,2a.33.33,0,0,1-.38,0l-2-1,.18-.11L7.39,1.3a.7.7,0,0,1,.71,0l1.82,1A.63.63,0,0,1,10.06,2.35Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M14.81,9.09a3.76,3.76,0,0,0-1.22-.2,4,4,0,1,0,1.22.2ZM15,15l-.54-1.6h-1.8l-.32,1-.2.62h-.68l.06-.19L13.2,10H14l.82,2.4L15.72,15Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M14.34,12.92H12.82l.49-1.47c.1-.31.18-.61.26-.91h0c.08.29.16.59.27.92Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccounting01);
export default __webpack_public_path__ + "static/media/accounting-01.0567f1c4.svg";
export { ForwardRef as ReactComponent };